import { AsyncEngine, ownTaskFilter, subscriptionTaskFilter, unknownTaskFilter } from "../pipe";
import { flatten, getTrackingNodeCount, render, updateRefs } from ".";
const log = (msg, ...data) => {
    console.log.apply(this, ['%c' + msg, 'color: green', ...data]);
};
export class BasicRenderer extends AsyncEngine {
    constructor() {
        super();
        this.roots = [];
    }
    attach(el, node) {
        this.roots.push({ el, node });
        !this.scheduled && this.schedule();
    }
    detach(node) {
        this.roots = this.roots.filter(root => root.node != node);
    }
    schedule() {
        if (this.scheduled) {
            return;
        }
        this.scheduled = true;
        queueMicrotask(() => {
            //        requestAnimationFrame(() => {
            log('[basic] render start');
            this.scheduled = false;
            if (this.roots.length == 0) {
                log('[basic] render suspend');
                return;
            }
            this.processing = true;
            let tasks = this.tasks;
            this.tasks = [];
            const rendered = this.roots.map(root => root.node.render(true));
            this.roots.forEach((root, i) => {
                try {
                    log('[basic] root render begin', tasks.length);
                    const out = { created: [], deleted: [] };
                    renderTree(rendered[i], out, el => {
                        root.el.append(el);
                        log('[basic] dom created');
                    });
                    updateRefs(out.created.concat(out.deleted));
                    log('[basic] render stats', out);
                    log('[basic] tracking', getTrackingNodeCount());
                    //root.el.append(el)
                    log('[basic] dom ready');
                    tasks
                        .filter(ownTaskFilter(this))
                        .filter(subscriptionTaskFilter(this.subscriptions))
                        .filter(unknownTaskFilter(this.subscriptions));
                    log('[basic] root render end', tasks.length);
                }
                catch (err) {
                    console.error(err);
                }
                //                debugger
                //                 ReactDOM.render(rendered[i], root.el, () => {
                // //                    console.log('[react] dom ready')
                //                     tasks
                //                         .filter(ownTaskFilter(this))
                //                         .filter(subscriptionTaskFilter(this.subscriptions))
                //                         .filter(unknownTaskFilter(this.subscriptions))
                //                     console.log('[react] render end', tasks.length)                    
                //                 })
            });
            this.processing = false;
            log('[basic] render finish', this.roots.length, tasks.length);
        });
    }
    get events() {
        return {};
    }
    isAttached(node) {
        return this.roots.find((root) => root.node == node) != null;
    }
    createVNode(key, vnodeProps, dom, children, changes) {
        const attributes = Object.assign({}, vnodeProps);
        return Object.assign({ children, dom, key, tag: dom.tag || 'div', attributes, events: dom.$eventHandlers }, changes);
        //     const tag = dom.tag
        //     const props: any = {
        //         ...vnodeProps,
        //         key, 
        //         className: dom.className, 
        //         style: dom.styles,
        // //        ref: dom.$ref
        //     }
        // if (dom.html) {
        //     props.dangerouslySetInnerHTML = {__html: dom.html}
        // }
        // if (dom.$isSubscribed) {
        //     let f = domMap.get(dom)
        //     if (f == null) {
        //         f = (el: HTMLElement) => dom.$publish(el)
        //         domMap.set(dom, f)
        //     }
        //     props.ref = f//(el: HTMLElement) => dom.$publish(el)
        // }
        // const events = dom.$eventHandlers
        // for (let n in events) {
        //     if (EVENT_MAP[n]) {
        //         props[EVENT_MAP[n]] = events[n]
        //     }
        // }
        // return tag === false ? children : React.createElement((!tag || tag === true ) ? 'div' : tag, props, children)
    }
}
//const domMap = new WeakMap<any, Function>()
export const createBasicRenderer = () => {
    return new BasicRenderer();
};
const renderTree = (vdom, output, ready) => {
    if (vdom == null || vdom.rendered) {
        return;
    }
    //console.log('render', vdom)
    render(vdom, vdom, output, ready);
    if (vdom.children) {
        flatten(vdom.children).forEach(child => renderTree(child, output, ready));
        delete vdom.children;
        delete vdom.attributes;
        delete vdom.events;
        delete vdom.styles;
        delete vdom.html;
        vdom.rendered = true;
    }
};
